import { createApp } from 'vue'
import { router, store } from '@/core'
import elementRegister from '@/elements'
import 'element-plus/theme-chalk/src/message.scss'
import 'element-plus/theme-chalk/src/message-box.scss'
import 'element-plus/theme-chalk/src/notification.scss'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@core/styles/index.scss'
import '@assets/styles/index.scss'
import 'driver.js/dist/driver.min.css'
import App from '@views/App.vue'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(elementRegister)

app.mount('#app')
